import { getUrlParam, getHash, getHashParam, setHashParam, setHash } from "dlibs";

// 是不是开发环境
export const isDev = () => {
    return import.meta.env.DEV;
}

export {
    getHash, getHashParam, getUrlParam, setHashParam, setHash
};

// 跳转到登录页面
export const toLoginPage = () => {
    if (!isDev()) {
        window.location.href = '/webmanage/index/login';
    } else {
        window.location.href = '/vue3/webmanage/ts/pages/index/login/index';
    }
}
// 跳转到首页
export const toIndexPage = () => {
    if (!isDev()) {
        window.location.href = '/webmanage/index/index';
    } else {
        window.location.href = '/vue3/webmanage/ts/pages/index/index/index';
    }
}


/**
 * 处理 URL：根据环境转换 URL 格式
 * @param url - 原始 URL，如 "bill/index/welcome"
 * @returns 处理后的 URL
 */
/**
 * 拼接 query 参数
 */
const appendParam = (baseUrl: string, param?: string): string => {
  return baseUrl;
  if (!param) return baseUrl;

  const urlObj = new URL(baseUrl, window.location.origin);
  const searchParams = new URLSearchParams(param);

  searchParams.forEach((value, key) => {
    urlObj.searchParams.set(key, value);
  });

  return urlObj.pathname + urlObj.search;
};

/**
 * 处理 URL：根据环境转换 URL 格式
 */
export const processUrl = (menuItem: MenuItem): string => {
  const { url, param } = menuItem;

  // 1. 外部链接（http/https）
  if (/^https?:\/\//i.test(url)) {
    return appendParam(url, param);
  }

  // 2. 清理基础路径
  const cleanUrl = '/' + url.replace(/^\/+/, '');

  // 3. 生产环境：直接返回后端路由
  if (!isDev()) {
    return appendParam(cleanUrl, param);
  }

  // 4. 开发环境：转换为 Vite 多页面路径
  const parts = url.replace(/^\/+/, '').split('/');

  if (parts.length >= 3) {
    const [app, controller, action] = parts;

    const devUrl = `/vue3/${app}/ts/pages/${controller}/${action}/index`;

    return appendParam(devUrl, param);
  }

  // 5. fallback（不符合规范的路径）
  return appendParam(cleanUrl, param);
};